/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { lazy } from 'react';
import styled from 'styled-components';

import { WidgetLazyLoadWrapper } from '../../common/utilities/widgetLazyLoadWrapper';
import { AnimatedLoadingPlaceholder } from '../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';

const WeatherCamsWidget = lazy(() => import('./weatherCamsWidget'));

export const WeatherCamsWidgetLazy = () => {
    return (
        <WidgetLazyLoadWrapper suspenseFallbackLoadingUI={<WeatherCamsWidgetLazyLoadingUI />}>
            <WeatherCamsWidget />
        </WidgetLazyLoadWrapper>
    );
};

const WeatherCamsWidgetLazyLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='100%' radius={3} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 250px;

    @media ${smallMediaQuery} {
        height: 170px;
    }
`;

